export const ISO_FORMAT = "YYYY-MM-DD";
export const ISO_MONTH = "YYYY-MM";
export const APP_DATE_FORMAT = "DD MMM YYYY";
export const APP_DATE_WITH_DAYNAME_FORMAT = "ddd, DD MMM YYYY";
export const JA_DATE_FORMAT = "YYYY年 MM月 DD日";
export const ZH_DATE_FORMAT = "YYYY年 MM月 DD日";
export const KO_DATE_FORMAT = "YYYY년 MM월 DD일";
export const ISO_TIME_FORMAT = "HH:mm";
export const DMY_FORMAT = "DD/MM/YYYY";
export const MONTH_YEAR_FORMAT = "MMMM YYYY";
export const JA_ZH_MONTH_YEAR_FORMAT = "YYYY年 MM月";
export const EVERYDAY = "Everyday";
export const WEEKEND = "Weekend";
export const WEEKDAY = "Weekday";
export const BLUE = "BLUE";
export const GREEN = "GREEN";
export const MIXED = "MIXED";
export const BLUE_GREEN = "BLUE_GREEN";
export const NOT_AVAILABLE = "NOT_AVAILABLE";
export const AVAILABLE_FOR_PRIVATE_CHARTER = "AVAILABLE_FOR_PRIVATE_CHARTER";
export const AVAILABLE = "AVAILABLE";
export const TWO_DAYS_ONE_NIGHT = "TWO_DAYS_ONE_NIGHT";
export const THREE_DAYS_TWO_NIGHTS = "THREE_DAYS_TWO_NIGHTS";

export const DATEPICKER_DATE_FORMAT = {
  en: APP_DATE_FORMAT,
  ja: JA_DATE_FORMAT,
  zh: ZH_DATE_FORMAT,
  ko: KO_DATE_FORMAT,
};

export const DATEPICKER_DATE_WITH_DAYNAME_FORMAT = {
  en: APP_DATE_WITH_DAYNAME_FORMAT,
  ja: JA_DATE_FORMAT,
  zh: ZH_DATE_FORMAT,
  ko: KO_DATE_FORMAT,
};
